<template>
<div id="fiberglass" class="w-100 tc black pb4">
    <div class="container w-100">
      
      <div class="relative dt w-100" :style="{ 'height': mobile ? '45vh': '80vh'}">
        <!-- <img class="w-100 banner dtc v-mid" src="https://d3fgmcoixbear.cloudfront.net/s3fs-public/sustainable%20insulation_6.jpg"/> -->
        <div class="w-100 b ph2 tc dtc white v-mid">
          <div class="f1">Denim Insulation </div>
          <!-- <div class="f2-ns f3 mt2">Batt & Blown Insulation</div> -->
        </div>
      </div>
      

      <div class="dt w-90-ns center ">
        <div class="w-50-ns w-100 pt4-ns pt2 pic-container" :class="[mobile ? 'dib' : 'dtc v-mid']">
          <div class="pa3"><img class="applegate" src="../assets/logos-color/ultra_touch_denim_logo.jpg"/></div>
          <div class="pa3"><img class="insul" src="https://elemental.green/wp-content/uploads/2016/04/3868.jpg"/></div>
          <!-- <div class="pa3"><img class="sustainable" src="../assets/sustainable.png"/></div> -->
        </div>

        <div class="pt4" :class="[mobile ? 'w-90 dib' : 'w-50 lh-copy f4 dtc v-mid']">
          <div class="tl t4 bullets">
            <h3 @click="expand1 = !expand1"><span class="mt2 f3" v-if="!expand1">+</span><span v-else class="mt2 f3">-</span> USE DENIM INSULATION</h3>
            <transition name="fade">
              <div v-if="expand1" class="">Denim is made from high-quality natural fibers. These fibers contain inherent qualities that provide for extremely effective sound absorption and maximum thermal performance. UltraTouch has No Fiberglass Itch and is easy to handle and work with. UltraTouch contains no chemical irritants and requires no warning labels compared to other traditional products. There are no VOC concerns when using UltraTouch, as it is safe for you and the environment.</div>
            </transition>
            <h3 @click="expand2 = !expand2"><span class="mt2 f3" v-if="!expand2">+</span><span v-else class="mt2 f3">-</span> WHERE TO USE DENIM INSULATION</h3>
              <div v-if="expand2" class="">Denim insulation can be used in both interior and exterior walls as well as most ceiling applications. The product easily installs in either wood or metal framing cavities by using a simple friction fit. The product is safe to handle and install without the need for protective clothing or special respiratory equipment.</div>

            <h3 @click="expand3 = !expand3"><span class="mt2 f3" v-if="!expand3">+</span><span v-else class="mt2 f3">-</span> DENIM INSULATION R-VALUES</h3>
              <div v-if="expand3" class="">UltraTouch provides maximum R-value performance. Denim insulation performs as well as fiberglass and cellulose with an average R-value of 3.5 per inch. It can be used to achieve LEED certification. UltraTouch offers an extremely high Noise Reduction Coefficient to effectively reduce airborne sound transmission including traffic, airplanes, radios, television, and conversation.</div>
          </div>
        </div>
      </div>

      <div class="resources pv5-ns pv3">
        <div class="f3 pb3">Specification Sheets</div>
        <div :class="[mobile ? '' : 'dt w-90 center']">
          <div :class="[mobile ? 'pv3 w-50 center' : 'ph1 w-20-ns center']">
            <a class=" spec link ps-blue dtc v-mid" href="http://bondedlogic.com/pdf/denim-insulation/UltraTouch-Denim-Spec-Sheet.pdf" target="_blank">
              <div class="f3">
              <img class="w-20-ns w-20" src="../assets/spec.png"/><br/>
              Denim Insulation 
              </div>
            </a>
          </div>
          
        </div>
      </div>

      <div class="w-20-ns tc w-70 mt4-ns mt2 center">
        <div class="f3-ns f4 pa1">
            <a class="link" :href="info.tel">
              <div class="contact-button ps-blue b br3 bg-yellow tc pa2 link"><i class="fa fa-phone mr3" style="font-size:20px"/>Call for a quote!<div class="">{{info.phone}}</div></div>
          </a> 
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Denim',
  props: ['info', 'mobile'],
  data() {
    return {
      expand1: false,
      expand2: false,
      expand3: false,
    };
  },
  methods: {
  },
  components: { 
  }
};
</script>

<style scoped>
.moreless {
  -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
  filter: invert(100%);
}
.spec {
  border: black 1px solid;
  padding: .5rem;
  margin: 0.5rem .5rem;
  border-radius: 2%;
}
.spec:hover{
  background: rgb(15,55,111);
  color: white;
}
.spec:hover img {
    -webkit-filter: invert(1);
}
h3 {
  padding: 1rem;
  border: solid black 1px;
  background: rgb(15,55,111);
  text-align: center;
  color: white;
}
#fiberglass {
  min-height: 85vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url("https://images.unsplash.com/photo-1516541196182-6bdb0516ed27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
  /* background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .7)), url("https://d3fgmcoixbear.cloudfront.net/s3fs-public/sustainable%20insulation_6.jpg");
  background-repeat: no-repeat;
  background-size: cover; */
}
.relative {
  background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .5)), url("https://www.diversifiede.com/wp-content/uploads/2019/04/denim-insulation-002.jpg");
  background-repeat: no-repeat;
  background-size: cover; 
  background-position: 50% 80%;
}
.banner {
  background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .7));
  max-height: 300px;
}
.absolute {
  top: 10%;
  right: 10%;
}
.applegate {
  max-height: 300px;
}
.sustainable {
  max-height: 100px;
}
.insul {
  max-height: 350px;
}
.contact-button {
  color: rgb(15,55,111) !important;
}

.contact-button:hover {
  background: rgb(15, 55, 111) !important;
  color: gold !important;
  box-shadow: gold 5px 5px !important;
  transition: .3s ease;
}

.contact-button {
  box-shadow: rgb(15,55,111) 5px 5px !important;
  background:gold 5px 5px !important;
  padding: .7rem !important;
  color: rgb(15, 55, 111) !important;
  transition: .3s ease;
}
.link {
  /* box-shadow: rgb(15,55,111) 3px 3px !important; */
  text-decoration: none;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>